import { c as _c } from "react/compiler-runtime";
export default function Development(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M86.8 79.96h-8.86V36.08a1 1 0 0 0-1-1H68.9a1 1 0 0 0-1 1v43.88h-6.92V51.5a1 1 0 0 0-1-1h-8.04a1 1 0 0 0-1 1v28.46h-6.91V42.11a1 1 0 0 0-1-1h-8.04a1 1 0 0 0-1 1v37.85h-6.92V53.88a1 1 0 0 0-1-1h-8.04a1 1 0 0 0-1 1v26.08H10V33.262l11.719 4.121a.994.994 0 0 0 .902-.121l16.443-11.413 16.404 9.272a1 1 0 0 0 1.186-.15L74.93 17.36l-.03 6.894a1 1 0 0 0 .996 1.005h.004a1 1 0 0 0 1-.996l.04-9.25c0-.016-.008-.03-.01-.047a.988.988 0 0 0-.27-.66.988.988 0 0 0-.752-.297L66.68 14a1.001 1.001 0 0 0-.002 2l6.775.007-17.65 17.006-16.302-9.214a1.002 1.002 0 0 0-1.062.05L21.9 35.326 10 31.142V15a1 1 0 0 0-2 0v65.96a1 1 0 0 0 1 1h77.8a1 1 0 1 0 0-2zM52.94 52.5h6.04v27.45h-6.04V52.5zm-33.91 2.38h6.04v25.07h-6.04V54.88zm16.96 25.08V43.11h6.04v36.85h-6.04zm33.91 0V37.08h6.04v42.88H69.9z" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="none" height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}